import React from 'react';
import { theme } from '@fiverr-private/theme';

const color = theme.colors.white;

export const GoLogoIcon = () => (
    <svg width="28" height="15" viewBox="0 0 38 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M26.7321 20C22.6239 20 19.6582 17.0343 19.6582 12.926C19.6582 8.8178 22.6239 5.85205 26.7321 5.85205C30.8404 5.85205 33.7793 8.8178 33.7793 12.926C33.7793 17.0343 30.8404 20 26.7321 20ZM26.7321 17.6882C29.3165 17.6882 31.0846 15.7295 31.0846 12.9276C31.0846 10.1258 29.3165 8.16697 26.7321 8.16697C24.1477 8.16697 22.3514 10.1258 22.3514 12.9276C22.3514 15.7295 24.1193 17.6882 26.7321 17.6882Z"
            fill={color}
        />
        <path
            d="M35.6398 20C36.6674 20 37.5003 19.167 37.5003 18.1394C37.5003 17.1119 36.6674 16.2789 35.6398 16.2789C34.6123 16.2789 33.7793 17.1119 33.7793 18.1394C33.7793 19.167 34.6123 20 35.6398 20Z"
            fill={color}
        />
        <path
            d="M21.1762 9.29193H9.54542V11.3029H14.5608C15.3713 11.3029 15.7175 12.0951 15.7515 12.849C15.8178 14.386 14.763 15.9796 13.3199 16.7384C12.3751 17.2351 11.236 17.5149 10.0517 17.5149C6.22562 17.5149 3.40396 14.7775 3.40396 10.0016C3.40396 5.22568 6.22562 2.56917 10.0809 2.56917C12.9575 2.56917 15.1934 4.21776 15.5832 6.59116H18.6006C18.209 2.73741 14.6901 0 10.0809 0C5.13678 0 0.5 3.3247 0.5 10C0.5 16.6752 5.08175 20 9.96928 20C12.7341 20 15.0817 18.5747 15.9198 16.4795V19.7751H18.5456V14.2048C18.5456 13.2519 18.235 12.0617 17.6607 11.2997H21.1762V9.55023V9.29193Z"
            fill={color}
        />
    </svg>
);

GoLogoIcon.id = 'GoLogoIcon';
GoLogoIcon.displayName = 'GoLogoIcon';
